import log from './useLogger'
export default async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    log.error(err)
  }
}
